<template>
    <v-layout v-if="loading" style="position: relative; min-height: 200px;" align-center justify-center>
        <loading></loading>  
    </v-layout>
    <v-flex v-else>
        <v-layout wrap>
            <v-flex xs12>
                <v-alert :value="error != null" outline type="error">
                    <span>{{ error }}</span>
                </v-alert>
            </v-flex>
        </v-layout>

        <v-layout wrap>
            <v-spacer></v-spacer>
            <v-flex xs12 sm2>
                <v-btn v-if="editMode" right class="primary mx-4" @click="showAddEditDialog(null)">Add</v-btn>
            </v-flex>
        </v-layout>
        
        <v-data-table :headers="headers" :items="cropWorkAbsences" no-data-text="Crop Work Attendance Member has no absences" hide-actions>
            <template v-slot:items="props">
                <td>{{ props.item.AbsenceType.Name }}</td>
                <td>{{ props.item.StartTime | formatDateTime}}</td>
                <td>{{ props.item.EndTime | formatDateTime }}</td>
                <td style="max-width: 10%">
                    <v-btn v-if="editMode" right class="primary" @click="showAddEditDialog(props.item)">Edit</v-btn>
                    <v-btn v-if="editMode" right class="error" @click="handleDelete(props.item)">Delete</v-btn>
                </td>
            </template>
        </v-data-table>

        <v-dialog :value="addEditDialog" max-width="500px" persistent @keydown.esc="handleCloseEdit()">
            <CropWorkAbsenceEdit v-if="addEditDialog" :editData="editCropWorkAbsence" :types="absenceTypes" :date="cropWorkAttendanceDate" :cropWorkAttendanceID="cropWorkAttendanceID" @close="handleCloseEdit()">
            </CropWorkAbsenceEdit>
        </v-dialog>
        
        <delete-dialog :DisplayDialog="showConfirmDelete" :DialogTitle="'Delete Item'" :DialogContents="'Are you sure you wish to delete this entry?'" @No="handleDeleteCancel" @Yes="handleDeleteConfirm"></delete-dialog>

    </v-flex>
</template>

<script>
import cropWorkAbsenceApi from '@/api/cropWorkAbsenceApi';
import Loading from '@/components/generic/Loading.vue';
import CropWorkAbsenceEdit from '@/components/plants/team/addEditCropWorkAbsence.vue';
import DeleteDialog from '@/components/generic/YesNoPopup.vue';

export default {
    components: {
        Loading,
        CropWorkAbsenceEdit,
        DeleteDialog,
    },
    props: {
        cropWorkAttendanceMemberID: {
            required: true,
            type: Number
        },
        cropWorkAttendanceID: {
            required: true,
            type: Number
        },
        editMode: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            loading: false,
            error: null,
            submitError: null,
            submitLoading: false,
            cropWorkAbsences: [],
            addEditDialog: false,
            editCropWorkAbsence: null,
            absenceTypes: [],
            cropWorkAttendanceDate: null,
            showConfirmDelete: false,
            targetCropWorkAbsence: null
        }
    },
    computed: {
        headers() {
            return  [
                { text: 'Type', value: 'AbsenceType', sortable: false  },
                { text: 'Start', value: 'StartTime'},
                { text: 'End', value: 'EndTime' },
                { text: 'Edit', value: 'Edit', sortable: false }
            ]
        },
        newCropWorkAbsence() {
            return {
                CropWorkAbsenceID: -1,
                AbsenceType: {
                    AbsenceTypeID: -1,
                    Name: null
                },
                CropWorkAttendanceMemberID: this.cropWorkAttendanceMemberID,
                StartTime: '1970-01-01T00:00:00',
                EndTime: '1970-01-01T00:00:00'
            }
        }
    },
    methods: {
        showAddEditDialog(targetCropWorkAbsence) {
            console.log(targetCropWorkAbsence)
            if(targetCropWorkAbsence == null){
                this.editCropWorkAbsence = JSON.parse(JSON.stringify(this.newCropWorkAbsence))
            }
            else {
                this.editCropWorkAbsence = JSON.parse(JSON.stringify(targetCropWorkAbsence))
            }
            this.addEditDialog = true;
        },
        handleDelete(item) {
            this.targetCropWorkAbsence = item;
            this.showConfirmDelete = true;
        },
        handleDeleteCancel() {
            this.targetCropWorkAbsence = null;
            this.showConfirmDelete = false;
        },
        async handleDeleteConfirm() {
            this.loading = true;
            //delete
            try{
                let response = await cropWorkAbsenceApi.deleteCropWorkAttendanceMemberAbsence(this.targetCropWorkAbsence);
                console.log(response);
                this.load();
            } catch (error) {
                console.log('error', error)
                this.error = error;
            }
            this.loading = false;
            this.targetCropWorkAbsence = null;
            this.showConfirmDelete = false;
        },
        handleCloseEdit() {
            this.targetCropWorkAbsence = null;
            this.addEditDialog = false;
            this.load()
        },
        async load() {
            this.loading = true;
            console.log('load')
            try {
                let cropWorkAbsenceDetail = await cropWorkAbsenceApi.getCropWorkAttendanceMemberAbsences(this.cropWorkAttendanceMemberID);
                this.cropWorkAbsences = cropWorkAbsenceDetail.CropWorkAbsences;
                this.absenceTypes = cropWorkAbsenceDetail.AbsenceTypes;
                this.cropWorkAttendanceDate = cropWorkAbsenceDetail.CropWorkAttendanceDate;
            } catch (error) {
                console.log('error', error)
                this.error = error;
            }

            this.loading = false;
        },
    },
    async created() {
        this.load();
    }
}
</script>